import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    usersList: {
      data: [],
      status: statuses.EMPTY,
    },
    userCreateData: {
      data: [],
      status: statuses.EMPTY,
    },
    userUpdateData: {
      data: [],
      status: statuses.EMPTY,
    },
    userCreate: {
      data: [],
      status: statuses.EMPTY,
    },
    userUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    userUpdateActive: {
      data: [],
      status: statuses.EMPTY,
    },
    userProfileUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    usersList: (state) => state.usersList,
    userCreateData: (state) => state.userCreateData,
    userUpdateData: (state) => state.userUpdateData,
    userCreate: (state) => state.userCreate,
    userUpdate: (state) => state.userUpdate,
    userUpdateActive: (state) => state.userUpdateActive,
    userProfileUpdate: (state) => state.userProfileUpdate,
  },
  mutations,
  actions,
};

export { store, defaultState };
